<template>
  <div>
    <DashboardTilesPackage
      :tiles="tiles"
      :currentUser="getCurrentUser"
      :currentCompany="getUserSchool"
    ></DashboardTilesPackage>
  </div>
</template>

<script>
import DashboardTilesPackage from "baron-vue-dashboard-tiles";
export default {
  components: {
    DashboardTilesPackage,
  },
  computed: {
    getCurrentUser() {
      return this.$store.getters.getCurrentUser;
    },
    getUserSchool() {
      return this.$store.getters.getUserSchool;
    },
  },
  props: {
    tiles: {
      default: () => [],
    },
  },
};
</script>
